export default "__VITE_ASSET__EofV1ny4__"